$(function () {
  if ($(".testimonials_block").length) {
    const swiper = new Swiper(".testimonials_block .swiper", {
      speed: 2000,
      spaceBetween: 30,
      navigation: {
        nextEl: ".testimonials_block .swiper-button-next",
        prevEl: ".testimonials_block .swiper-button-prev",
      },
    });
  }

  if ($(".mobile_block").length) {
    const swiper = new Swiper(".mobile_block .swiper", {
      speed: 2000,
      spaceBetween: 30,
      navigation: {
        nextEl: ".mobile_block .swiper-button-next",
        prevEl: ".mobile_block .swiper-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: ".mobile_block .swiper-pagination",
        clickable: true,
      },
    });
  }

  if ($(".works_slider").length) {
    const swiper = new Swiper(".worksSwiper", {
      speed: 600,
      spaceBetween: 30,
      navigation: {
        nextEl: ".works_slider .swiper-button-next",
        prevEl: ".works_slider .swiper-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: 6,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: ".works_slider .swiper-pagination",
        clickable: true,
      },
    });
  }

  $('body').on('click', '.toggle', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('show')) {
            $this.next().removeClass('show');
            $this.removeClass('open');
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find('li .inner').removeClass('show');
            $this.parent().parent().find('li .toggle ').removeClass('open');
            $this.parent().parent().find('li .inner').slideUp(350);
            $this.next().toggleClass('show');
            $this.toggleClass('open');
            $this.next().slideToggle(350);
        }
    });
});
